import { AuthClient } from '@dx-ui/framework-auth-provider';
import { env } from '@dx-ui/framework-env';
import { isBrowser } from '@dx-ui/utilities-is-browser';
import { getServerSideSafeLanguage } from '@dx-ui/framework-react-query';
import type { GetServerSidePropsContext, NextPageContext } from 'next';
import { DXError, GraphError, ServerAuthError } from '@dx-ui/types-graphql';

const graphqlErrorCode = (error?: GraphError) => {
  const graphQLErrorsCode = error?.graphQLErrors?.[0]?.extensions?.code || '0';
  return parseInt(graphQLErrorsCode, 10);
};

export const isCausedBy403 = (error: DXError) => {
  if (error instanceof ServerAuthError) {
    return error.statusCode === 403;
  }
  return graphqlErrorCode(error) === 403;
};
export const getAuthClient = (
  context: GetServerSidePropsContext | NextPageContext,
  initialAuthState?: ConstructorParameters<typeof AuthClient>[0]['restore']
): AuthClient => {
  const { req } = context;
  const locale = getServerSideSafeLanguage(context);
  return new AuthClient({
    authEndpoint: (isBrowser
      ? env('DX_AUTH_API_CLIENT_URI')
      : process.env.DX_AUTH_API_SERVER_URI) as string,
    gqlEndpoint: (isBrowser
      ? env('DX_GRAPHQL_CLIENT_URI')
      : process.env.DX_GRAPHQL_SERVER_URI) as string,
    appId: env('DX_AUTH_API_CUSTOMER_APP_ID'),
    request: req,
    restore: initialAuthState,
    appName: 'my-event',
    language: locale,
  });
};

export function isCMSError(graphQLErrors: GraphError) {
  return graphQLErrors.graphQLErrors?.[0]?.code === 998;
}
